import React from 'react';
import { useTranslation } from 'react-i18next';

interface DevToolsBlockOverlayProps {
  /** When true, the overlay is shown (blocking interaction) */
  show: boolean;
}

/**
 * Full-screen overlay shown when DevTools are detected and ?devTools=true is not in the URL.
 * Informs the user to close DevTools; developers can add ?devTools=true to disable this check.
 */
export const DevToolsBlockOverlay: React.FC<DevToolsBlockOverlayProps> = ({ show }) => {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 text-white p-4"
      style={{ pointerEvents: 'auto' }}
      role="alert"
      aria-live="assertive"
    >
      <div className="bg-gray-900 rounded-2xl shadow-2xl max-w-md w-full p-6 text-center">
        <h2 className="text-xl font-bold mb-2">{t('exam.devToolsOverlay.title')}</h2>
        <p className="text-gray-300 mb-4">
          {t('exam.devToolsOverlay.message')}
        </p>
        <p className="text-sm text-gray-500">
          {t('exam.devToolsOverlay.devNote', { param: '?devTools=true' })}
        </p>
      </div>
    </div>
  );
};

export default DevToolsBlockOverlay;
